import { Deserializable } from '../protocols/deserializable';

export class ReleaseNoteDocumentVersion implements Deserializable {
  public version!: string;

  onDeserialize(): void {}
}
